// @ts-strict-ignore
import { useEffect, useRef } from "react";

import { AnalyticsEvent } from "@shared/hooks/useAnalyticsLogger/AnalyticsEvent";
import { PatientAppViewEntryPoint } from "@shared/hooks/useAnalyticsLogger/PatientAnalyticsEntryPoint";
import { useAnalyticsLogger } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { usePlatform } from "@shared/hooks/usePlatform/usePlatform";
import { useUnauthUrlFields } from "@shared/hooks/useUnauthUrlFields/useUnauthUrlFields";

import { handleBeforeReactSmartBannerEvents } from "./smartBannerUtil";

const docEventRef = handleBeforeReactSmartBannerEvents();

const SmartBannerEvents = () => {
  const onViewHandled = useRef(false);
  const logAnalyticsEvent = useAnalyticsLogger();
  const unauthUrlFields = useUnauthUrlFields();
  const { isIOS, isAndroid } = usePlatform();

  useEffect(() => {
    const logAppStoreView = () => {
      const analyticsEvent = AnalyticsEvent.PATIENT_WEB_MOBILE_SMART_BANNER_CLICK_GET;
      if (isIOS || isAndroid) {
        logAnalyticsEvent({
          eventName: analyticsEvent,
          payload: {
            ...unauthUrlFields,
            entry_point: PatientAppViewEntryPoint.SMART_BANNER,
          },
        });
      }
    };

    const adjustStickyBar = () => {
      const smartBanner: HTMLElement = document.querySelector(".smartbanner");

      if (smartBanner) {
        const bannerHeight = smartBanner.offsetHeight;
        document.documentElement.style.setProperty("--smartbanner-height", bannerHeight + "px");
      } else {
        document.documentElement.style.setProperty("--smartbanner-height", "0px");
      }
    };

    const onView = () => {
      onViewHandled.current = true;

      adjustStickyBar();
    };

    const manuallyInvokeView =
      docEventRef.smartBannerViewBeforeReactReady && !onViewHandled.current;
    if (manuallyInvokeView) {
      onView();
    }

    const setupViewEventHandler = !manuallyInvokeView;
    if (setupViewEventHandler) {
      document.addEventListener("smartbanner.view", onView);
    }
    document.addEventListener("smartbanner.exit", adjustStickyBar);
    document.addEventListener("smartbanner.clickout", logAppStoreView);

    return () => {
      if (setupViewEventHandler) {
        document.removeEventListener("smartbanner.view", onView);
      }
      document.removeEventListener("smartbanner.exit", adjustStickyBar);
      document.removeEventListener("smartbanner.clickout", logAppStoreView);
    };
  }, [logAnalyticsEvent, unauthUrlFields]);

  return null;
};

export { SmartBannerEvents };
